import { render, staticRenderFns } from "./ram-viewer-button.vue?vue&type=template&id=371064ee&scoped=true"
import script from "./ram-viewer-button.vue?vue&type=script&lang=js"
export * from "./ram-viewer-button.vue?vue&type=script&lang=js"
import style0 from "./ram-viewer-button.vue?vue&type=style&index=0&id=371064ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371064ee",
  null
  
)

export default component.exports